<template>
	<div v-editable="blok" class="grid grid-cols-1" :class="blok?.offset || ''">
		<StoryblokComponent
			v-for="body in blok.body"
			:key="body._uid"
			:blok="body"
		/>
	</div>
</template>

<script setup lang="ts">
import type { BlokPage } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokPage;
}
const { blok } = defineProps<Props>();
</script>
